<div class="vstack gap-3">
    <div class="vstack gap-2">
        <h5 class="fw-semibold m-0 px-3">
            Reason for your visit
        </h5>
    </div>
    <div class="vstack gap-2">
        @if (shouldShowReasonSelection) {
            @if (reasonsAtIdealTime.length > 0) {
                <div
                    class="vstack gap-2"
                    data-testid="reasons-at-ideal-time"
                >
                    <h6 class="fw-medium m-0 px-3 text-muted">
                        Here's what's on at {{ form.get('idealTime')?.value | date : 'shortTime' }}:
                    </h6>
                    @for (reason of reasonsAtIdealTime; track reason.reason.id) {
                        <ng-container
                            *ngTemplateOutlet="reasonLabel; context: { reason: reason.reason, isFull: reason.isFull }"
                        >
                        </ng-container>
                    }
                </div>
            }
            @if (reasonsOutsideIdealTime.length > 0) {
                <hr class="my-1 border-secondary-subtle" />
                <div
                    class="vstack gap-2"
                    data-testid="reasons-outside-ideal-time"
                >
                    <h6 class="fw-medium m-0 px-3 text-secondary">
                        Not quite what you were thinking?
                        <br />
                        Here's what else we have going on:
                    </h6>
                    @for (reason of reasonsOutsideIdealTime; track reason.reason.id) {
                        <ng-container
                            *ngTemplateOutlet="reasonLabel; context: { reason: reason.reason, isFull: reason.isFull }"
                        >
                        </ng-container>
                    }
                </div>
            }
        } @else {
            <app-no-availability
                [availability]="availability"
                [requiresDogFriendly]="form.get('requiresDogFriendly')?.value"
                [idealTime]="form.get('idealTime')?.value"
                [partySize]="form.get('partySize')?.value"
                [areaId]="form.get('selectedAreaId')?.value"
                [eventId]="form.get('selectedEventId')?.value"
                [reasonId]="form.get('selectedReasonId')?.value"
                (joinWaitlistRequested)="joinWaitlistRequested.emit()"
            >
            </app-no-availability>
        }
    </div>
    @if (shouldShowReasonSelection) {
        <div class="vstack gap-2">
            @if (showValidationError) {
                <div class="text-danger small px-3">
                    Please select a reason for your visit.
                </div>
            }
            <button
                class="btn btn-primary"
                type="button"
                (click)="next()"
                [disabled]="isLoading"
            >
                Next
            </button>
        </div>
    }
</div>

<ng-template
    #reasonLabel
    let-reason="reason"
    let-isFull="isFull"
>
    <app-reason-card
        [reason]="reason"
        [date]="form.get('idealTime')?.value"
        [isFull]="isFull"
        [isSelected]="selectedReason?.id === reason.id"
        [attr.data-testid]="'reason-' + reason.displayName"
        (reasonSelected)="onReasonSelected(reason)"
    >
    </app-reason-card>
</ng-template>
